import React from 'react'
import useLookupService from '../../../../../services/lookup/useLookupService'
import * as closeProjectFormType from './closeProjectResearcherType'
import * as REQServiceTypes from '../../../../../services/web/types/requestWebServiceTypes'
import { DialogType } from '../../../../../control/dialog/dialog'
import useLoading from '../../../../../control/loading/useLoading'
import useWebService from '../../../../../services/web/useWebService'
import useFolderAndTabStore from '../../../../../stores/appFolderAndTab/appFolderAndTabStore'
import { useHistory } from 'react-router-dom'
import { RoutePath } from '../../../../../router/routesConfig'
import { customFolder, topicForLecturer, topicForStudent } from '../../../../../constants/constants'
import constSubmittedType from '../../../../../constants/submittedType'
import useManageProjectAction from '../../../../../stores/manageProject/useManageProjectAction'
import useManageProjectStore from '../../../../../stores/manageProject/useManageProjectStore'
import { ResultDocumentTopicLut } from '../../../../../services/lookup/types/responseLookupServiceTypes'
import useAppFolderAndTabAction from '../../../../../stores/appFolderAndTab/appFolderAndTabAction'
import useTranslate from '../../../../../i18n/useTranslate'
import checkPermission from '../../../../../utilities/checkPermission'
import { UploadFileObjType } from './closeProjectResearcherType'
import { checkAllAdditionalDocTopicsHavePdf, withFileTokenInfo } from '../../../../../utilities/additionalDoc'

const useCloseProjectResearcher = (props: closeProjectFormType.UseCloseProjectFormType) => {
    const [initialValues, setInitialValues] = React.useState<any>({})
    const [initialUploadFile, setInitialUploadFile] = React.useState<any>()
    const parameterForSaveRef = React.useRef<any>()
    const submitValueRef = React.useRef<any>()
    const isDraftRef = React.useRef<boolean>(false)
    const dialogTwoRef = React.useRef<Record<string, Function>>()
    const projectIDRef = React.useRef<number>()
    const submittedIDRef = React.useRef<number>()
    const irbRef = React.useRef<number>()
    const [configDialog, setConfigDialog] =
        React.useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const { loadingClose, loadingOpen } = useLoading()
    const callLookup = useLookupService()
    const callWebService = useWebService()
    const history = useHistory()
    const translate = useTranslate()
    const checkPermissionHook = checkPermission()

    // --- Store --- //
    const folderAndTabStore = useFolderAndTabStore()
    const appFolderAndTabAction = useAppFolderAndTabAction()
    const manageProjectAction = useManageProjectAction()
    const manageProjectStore = useManageProjectStore()
    const { documentTopic, projectData } = manageProjectStore
    const { folderSelected } = folderAndTabStore
    const isViewMode = checkPermissionHook.chkProjectStepViewMode(projectData)
    type MyFileDataType = {
        documentTopicID?: number
        fileTokenInfo: Array<{
            fileID: any
            replaceFileID: number
            fileToken: string
            fileExtension?: string
        }>
        subtopic?: {
            subtopicID: number
            page: number | string
        }[]
    }
    React.useEffect(() => {
        if (projectData) {
            createInitialData()
            loadDocumentTopic()
        }
    }, [projectData?.submittedID])

    const loadDocumentTopic = async () => {
        if (projectData?.irb) {
            const lstDocumentTopic = await getDocumentTopicLut(projectData?.irb, constSubmittedType.closeProject)

            manageProjectAction.setDocumentTopic(lstDocumentTopic)
            createInitialUploadFile(lstDocumentTopic)
        }
    }

    const getDocumentTopicLut = async (irb: number, submitTypeID: number) => {
        const res = await callLookup.callDocumentTopicLut(irb, submitTypeID)
        if (res.status === 1) {
            let docTopic = res.result
            //กรองหัวข้อตามประเภทนักวิจัย กรณีที่มีข้อมูล projectData
            if (manageProjectStore.projectData?.researcherTypeInfo.value) {
                const researcherTypeID = manageProjectStore.projectData?.researcherTypeInfo.value
                docTopic = filterTopicUpload(researcherTypeID, res.result)
            }
            return docTopic
        } else {
            return []
        }
    }

    const filterTopicUpload = (researcherTypeID: number, documentTopic: ResultDocumentTopicLut[]) => {
        let docTopic: ResultDocumentTopicLut[] = []
        if (documentTopic) {
            let isDocTopic = documentTopic
            if (researcherTypeID === 1) {
                topicForLecturer.forEach((element) => {
                    docTopic = isDocTopic?.filter((item) => {
                        return item.id !== element.id
                    })
                })
            } else {
                topicForStudent.forEach((element) => {
                    docTopic = isDocTopic?.filter((item) => {
                        return item.id !== element.id
                    })
                    isDocTopic = docTopic
                })
            }
            if (docTopic.length > 1) {
                docTopic = docTopic?.map((itm, index: number) => {
                    return { ...itm, no: index + 1 }
                })
            }
        }
        return docTopic
    }

    const createInitialData = () => {
        const initialData = {
            remarkFromAdmin: projectData?.verifyDocumentRemark || null,
        }

        setInitialValues(initialData)
    }

    const createInitialUploadFile = (documentTopicInfo: Array<ResultDocumentTopicLut>) => {
        let uploadFileinit = documentTopicInfo?.map((itm: any, idx: number) => {
            return {
                uploadFileObj: {
                    fileList: [],
                    subTopicPageList: [],
                    documentTopicID: itm.id,
                    isDisplay: itm.isDisplay,
                    isRequired: itm.isRequired,
                },
            }
        }) as Array<closeProjectFormType.UploadFileObjType>

        if (folderSelected.id !== customFolder.closeProject.id) {
            uploadFileinit?.forEach((itm: closeProjectFormType.UploadFileObjType) => {
                projectData?.documentInfo?.forEach((docInfo) => {
                    if (docInfo.topicID === itm.uploadFileObj.documentTopicID) {
                        //@ts-ignore
                        itm.uploadFileObj.fileList = docInfo.fileInfo
                        //@ts-ignore
                        itm.uploadFileObj.subTopicPageList = docInfo.subtopic
                    }
                })
            })
        }

        //Section Replace File
        let latestDocument = projectData?.latestDocument
        if (latestDocument && latestDocument?.length > 0) {
            uploadFileinit?.forEach((initFileItm) => {
                //loop structure init file

                latestDocument?.forEach((docItm) => {
                    //loop document topic
                    const docFileInfo = docItm.fileInfo

                    docFileInfo?.forEach((replaceFileItm: any) => {
                        //loop file in document
                        const lstReplaceFileGroup: Array<any> = replaceFileItm.latestFileList
                        const replaceFile = lstReplaceFileGroup.filter((file) => file.no !== null)?.[0] //ไฟล์เก่าที่ถูกแทนที่
                        const replaceFileBy = lstReplaceFileGroup.filter((file) => file.no === null)?.[0] //ไฟล์ใหม่ที่นำมาแทนที่
                        if (replaceFile && replaceFileBy) {
                            if (docItm.topicID === initFileItm.uploadFileObj.documentTopicID) {
                                initFileItm.uploadFileObj.fileList = [
                                    ...initFileItm.uploadFileObj.fileList,
                                    {
                                        documentTopicID: docItm.topicID,
                                        fileToken: replaceFileBy.fileToken, //fileToken
                                        filename: replaceFileBy.filename,
                                        fileID: replaceFileBy.fileID, //fileToken
                                        path: replaceFileBy.path,
                                        replaceFileID: replaceFileBy.replaceFileID,
                                    } as any,
                                ]

                                const subtopic = docItm.subtopic?.map((sub: any) => ({
                                    page: sub.page,
                                    documentTopicID: docItm.topicID,
                                    subtopicID: sub.subtopicID,
                                }))
                                //ห้าม overwrite ทับค่า subTopicPageList เดิมถ้า latestDocument ไม่มีข้อมูล subtopic
                                if (subtopic && subtopic.length > 0) {
                                    initFileItm.uploadFileObj.subTopicPageList = subtopic
                                }
                            }
                        }
                    })
                })
            })
        }

        //Filter การซ่อนแสดงหัวข้อเอกสาร ถ้าฝั่งสำนักงานให้ซ่อนหัวข้อเอกสาร แต่ว่าหัวข้อนั้นมีไฟล์อยู่ให้ทำการแสดงหัวข้อนั้นออกมา
        if (uploadFileinit?.length > 0) {
            uploadFileinit = uploadFileinit.filter((itm: any) => {
                return itm.uploadFileObj.isDisplay || itm.uploadFileObj.fileList.length !== 0
            })
        }
        setInitialUploadFile(uploadFileinit)
    }

    const handelClickSubmit = (val: any) => {
        submitValueRef.current = val
        const projectID = projectData?.projectID ?? null
        let submittedID: number | null = folderSelected.submittedID
        if (folderSelected.submittedID === customFolder.closeProject.submittedID) {
            submittedID = null
        }
        const parameterForSave: REQServiceTypes.CloseProject = {
            projectID: projectID,
            submittedID: submittedID,
            isDraft: null,
            documentInfo: getDocumentInfo(val),
            documentAdditionalInfo: withFileTokenInfo(val.documentAdditionalInfo),
            coResearcher: projectData?.coResearcher as any,
            form: val?.form ?? [],
        }

        parameterForSaveRef.current = parameterForSave
        switch (val.submitType) {
            case 'save':
                // code block
                isDraftRef.current = false
                handleSave()

                break

            case 'draft':
                // code block
                isDraftRef.current = true
                handleSaveDraft()

                break
            default:
                break
        }
    }

    const getDocumentInfo = (val: any) => {
        let fileDataList = val.uploadFile.filter((itm: any) => itm.uploadFileObj.fileList.length > 0)
        let myFileData: Array<REQServiceTypes.DocumentInfo> = []

        fileDataList.forEach((uploadObj: UploadFileObjType) => {
            const subTopicLst = uploadObj?.uploadFileObj.subTopicPageList?.map((subtopic) => {
                return {
                    subtopicID: subtopic.subtopicID,
                    page: subtopic.page,
                }
            })

            const fileTokenInfo: Array<{
                replaceFileID: number
                fileToken: string
                fileExtension?: string
                fileID: any
            }> =
                uploadObj.uploadFileObj.fileList?.map((file) => {
                    return {
                        //@ts-ignore
                        replaceFileID: file?.replaceFileID ? file.replaceFileID : null,
                        fileToken: file.fileToken,
                        fileExtension: file.filename.split('.').pop(),
                        fileID: file?.fileID ? file.fileID : null,
                    }
                }) ?? []

            myFileData.push({
                documentTopicID: uploadObj?.uploadFileObj?.documentTopicID,
                fileTokenInfo: fileTokenInfo,
                subtopic: subTopicLst && subTopicLst.length > 0 ? subTopicLst : [],
            })
        })

        return myFileData
    }

    const checkRequirePDF = (documentInfo: MyFileDataType[]) => {
        let isRequirePDF = false

        for (let i = 0; i < documentInfo?.length; i++) {
            if (!isRequirePDF) {
                for (let j = 0; j < documentInfo[i]?.fileTokenInfo.length; j++) {
                    if (documentInfo[i]?.fileTokenInfo[j]?.fileExtension === 'pdf') {
                        isRequirePDF = false
                        break
                    } else {
                        isRequirePDF = true
                    }
                }
            }
        }
        return isRequirePDF
    }

    const checkSubtopic = (documentInfo: MyFileDataType[]) => {
        let isEmptyPage = false

        //หาว่าหัวข้ออัปโหลดเอกสารมีให้อัปโหลดหัวข้อย่อยมั้ย
        const docTopic = manageProjectStore.documentTopic?.filter((item) => item.subtopic.length > 0)

        //ถ้ามีให้เข้าไปเช็คตามเงื่อนไข if
        if (docTopic?.length) {
            // วน loop หัวข้อที่มีให้อัปโหลดเอกสารหัวข้อย่อย
            docTopic.forEach((mainTopic) => {
                // วน loop หัวข้อที่มีการอัปโหลดเอกสารเข้ามา
                documentInfo.forEach((itm) => {
                    // เช็คว่าเอกสารที่มีการอัปโหลดเข้ามาใช่เอกสารที่มีหัวข้อย่อยให้อัปโหลดหรือป่าว
                    if (mainTopic.id === itm.documentTopicID) {
                        // เช็คว่าหัวข้อย่อยที่อัพโหลดเข้ามาครบมั้ย
                        if (itm.subtopic?.length != mainTopic.subtopic.length) {
                            isEmptyPage = true
                        } else {
                            // เช็คว่าที่อัปมาครบมีช่องไหนกรอกเป็น ช่องว่างมั้ย
                            const chkEmpty = itm.subtopic.find(
                                (e) => e.page == null || e.page == '' || e.page == undefined,
                            )
                            if (chkEmpty) {
                                isEmptyPage = true
                            }
                        }
                    }
                })
            })
        }

        return isEmptyPage
    }

    const validateRequiredUploadFile = (uploadFile: Array<{ uploadFileObj: any }>, skipValidate: boolean = false) => {
        let isValid = true
        if (!skipValidate) {
            uploadFile?.every(({ uploadFileObj: file }) => {
                if (file?.isRequired && file?.fileList?.length === 0) {
                    //เป็นหัวข้อที่มีการ required แต่ว่าไม่ upload เอกสาร
                    isValid = false
                    return false //break
                }
                return true //continue
            })

            if (!isValid) {
                setConfigDialog({
                    title: translate.get('ALERT.TITLE.NOTIFICATION'),
                    content: translate.get2Element('ALERT.CONTENT.PLEASE_UPLOAD_REQUIRED_TOPIC', [
                        '<label style="color: red;">*</label>',
                    ]) as any,
                    type: 'alert-message',
                })
                dialogTwoRef.current?.openDialog()
            }
        }
        return isValid
    }

    const validateForm = (form?: REQServiceTypes.DocumentTopic[]): boolean => {
        if (!Array.isArray(form) || form.length === 0) return true

        return form.every((topic) => {
            const topicsToCheck = topic.subTopics ?? [topic]

            return topicsToCheck.every((t) => !t.answers || t.answers.some((answer) => answer.checked))
        })
    }

    const handleSave = () => {
        if (validateRequiredUploadFile(submitValueRef.current.uploadFile)) {
            parameterForSaveRef.current.isDraft = false
            if (parameterForSaveRef.current?.documentInfo?.length === 0) {
                setConfigDialog({
                    title: translate.get('ALERT.TITLE.NOTIFICATION'),
                    content: translate.get('ALERT.CONTENT.UPLOAD_AT_LEAST_1_FILE'),
                    type: 'alert-message',
                })
            } else {
                const isRequirePDF = checkRequirePDF(parameterForSaveRef.current?.documentInfo)
                const allAdditionalDocTopicsHavePdf = checkAllAdditionalDocTopicsHavePdf(
                    parameterForSaveRef.current?.documentAdditionalInfo,
                )
                const isEmptyPage = checkSubtopic(parameterForSaveRef.current?.documentInfo)

                const isFormValid = validateForm(parameterForSaveRef.current?.form)

                if (isRequirePDF || !allAdditionalDocTopicsHavePdf) {
                    setConfigDialog({
                        title: translate.get('ALERT.TITLE.NOTIFICATION'),
                        content: translate.get('ALERT.CONTENT.UPLOAD_PDF_AT_LEAST_1_FILE'),
                        type: 'alert-message',
                    })
                } else if (isEmptyPage) {
                    setConfigDialog({
                        title: translate.get('ALERT.TITLE.NOTIFICATION'),
                        content: translate.get('ALERT.CONTENT.PLEASE_COMPLETE_PAGE'),
                        type: 'alert-message',
                    })
                } else if (!isFormValid) {
                    setConfigDialog({
                        title: translate.get('ALERT.TITLE.NOTIFICATION'),
                        content: translate.get('ALERT.CONTENT.PLEASE_COMPLETE_PROJECT_COMPLETION_FORM'),
                        type: 'alert-message',
                    })
                } else {
                    setConfigDialog({
                        title: translate.get('ALERT.TITLE.NOTIFICATION'),
                        content: translate.get('ALERT.CONTENT.NEED_TO_SAVE'),
                        type: 'alert-confirm',
                        onClickConfirm: handleClickConfirmSave,
                    })
                }
            }

            dialogTwoRef.current?.openDialog()
        }
    }

    const handleSaveDraft = async () => {
        parameterForSaveRef.current.isDraft = true
        handleClickConfirmSave()
    }
    const handleClickCancel = (dirty: boolean) => {
        if (dirty) {
            setConfigDialog({
                title: translate.get('ALERT.TITLE.WARNING'),
                content: translate.get('ALERT.CONTENT.NEED_TO_CANCEL'),
                type: 'alert-confirm',

                onClickConfirm: () => {
                    history.push(RoutePath.manageProject)
                },
            })
            dialogTwoRef.current?.openDialog()
        } else {
            history.push(RoutePath.manageProject)
        }
    }
    const onRefDialogTwo = (func: Record<string, Function>) => {
        //ห้าม set State หรือเรียก Action ในนี้
        dialogTwoRef.current = func
    }

    const handleClickConfirmSave = async () => {
        loadingOpen()
        const res = await callWebService.closeProject(parameterForSaveRef.current)

        if (res.status === 1) {
            loadingClose()
            setConfigDialog({
                title: translate.get('ALERT.TITLE.NOTIFICATION'),
                content: translate.get('ALERT.CONTENT.SAVE_SUCCESS'),
                type: 'alert-message',
                onAfterClose: loadLatestFolder,
            })
            dialogTwoRef.current?.openDialog()
            projectIDRef.current = res.result?.projectInfo.projectID
            submittedIDRef.current = res.result?.projectInfo.submittedID
            irbRef.current = res.result?.projectInfo.irb
        } else {
            loadingClose()
            setConfigDialog({
                title: translate.get('ALERT.TITLE.ERROR'),
                content: translate.get('ALERT.CONTENT.SAVE_NOT_SUCCESS'),
                type: 'alert-message',
            })
            dialogTwoRef.current?.openDialog()
        }
    }

    const loadLatestFolder = async () => {
        try {
            loadingOpen()
            const currentProjectID = manageProjectStore.projectData?.projectID
            manageProjectAction.setProjectData()
            if (currentProjectID) {
                const resProjectFolder = await callWebService.getProjectFolder(currentProjectID)

                const projectFolder = resProjectFolder.result?.folders?.map((itm: any, index: number) => {
                    return {
                        ...itm,
                        id: itm.submittedID,
                        isLastProcess: index === 0 ? true : false,
                    }
                })

                if (projectFolder?.length !== 0) {
                    appFolderAndTabAction.setState({
                        folderList: projectFolder,
                        folderSelected: projectFolder[0],
                    })
                }
                if (projectFolder?.length !== 0) {
                    const selectedFolder = projectFolder[0]
                    const resProject = await callWebService.getProjectByID(currentProjectID, selectedFolder.submittedID)
                    if (resProject.result) {
                        manageProjectAction.setProjectData(resProject.result)
                    }
                }
            }
        } catch (ex) {
        } finally {
            loadingClose()
        }
    }
    const handleDirtyChange = (props: any) => {
        appFolderAndTabAction.setTabDirty(props.dirty)
    }

    const checkUseUploadEdit = () => {
        let isUseUploadEdit = false

        switch (projectData?.submitTypeInfo?.value) {
            case constSubmittedType.editAfterReview_closeProject:
                isUseUploadEdit = true
                break
            default:
                isUseUploadEdit = false
        }

        return isUseUploadEdit
    }
    const handleDeleteProject = () => {
        setConfigDialog({
            title: translate.get('ALERT.TITLE.WARNING'),
            content: translate.get('ALERT.CONTENT.NEED_TO_DELETE'),
            type: 'alert-confirm',

            onClickConfirm: async () => {
                if (manageProjectStore?.projectData?.projectID) {
                    const res = await callWebService.deleteProject(manageProjectStore?.projectData?.projectID)
                    setConfigDialog({}) //clear function dialog
                    history.push('/manage-project')
                }
            },
        })
        dialogTwoRef.current?.openDialog()
    }

    const chkDisplayBTNDeleteProject: boolean =
        (projectData?.submitTypeInfo &&
            checkPermissionHook.chkDisplayBTNDeleteProject(projectData?.submitTypeInfo?.value) &&
            projectData?.isDraft &&
            manageProjectStore.projectData?.verifyDocument == null) ||
        false

    return {
        isDraftData: chkDisplayBTNDeleteProject,
        projectData,
        isViewMode,
        initialValues,
        documentTopicList: documentTopic,
        initialUploadFile,
        configDialog,
        onRefDialogTwo,
        handleDirtyChange,
        onClickSubmit: handelClickSubmit,
        onClickCancel: handleClickCancel,
        onClickDeleteProject: handleDeleteProject,
        checkUseUploadEdit,
    }
}

export default useCloseProjectResearcher
